import { z } from 'zod';

export const ColorRangeSchema = z.object({
    min: z.number(),
    max: z.number(),
    color: z.string(),
    label: z.string().optional(),
});

export const LevelSchema = z.object({
    label: z.string().min(1),
    multiplier: z.number().positive(),
    description: z.string().optional().default(''),
});

export const RiskMatrixSchema = z.object({
    rows: z.array(LevelSchema),
    columns: z.array(LevelSchema),
    colorRanges: z.array(ColorRangeSchema),
});

export const CiaMatrixSchema = z.object({
    confidentialityLevels: z.array(LevelSchema),
    integrityLevels: z.array(LevelSchema),
    availabilityLevels: z.array(LevelSchema),
    colorRanges: z.array(ColorRangeSchema),
});

export const MatrixConfigurationPayloadSchema = z.object({
    id: z.unknown().optional(),
    riskMatrix: RiskMatrixSchema.optional(),
    ciaMatrix: CiaMatrixSchema.optional(),
});

export const MatrixConfigurationResponseSchema = z.object({
    success: z.boolean(),
    data: z.unknown(),
    message: z.string().optional(),
});

/** @deprecated Use MatrixConfigurationResponseSchema */
export const EntityValueResponseSchema = MatrixConfigurationResponseSchema;
